import { Style } from 'index';

const ProjectCurationStepStyles: Style = {
    checkIcon: {
        color: 'success.main',
        marginBottom: '5px',
    },
    closeIcon: {
        color: 'error.dark',
        marginBottom: '5px',
    },
    questionMarkIcon: {
        color: 'warning.dark',
        marginBottom: '5px',
    },
};

export default ProjectCurationStepStyles;
